import { inject, InjectionToken, Signal } from '@angular/core';
import { UserProfileSignalBridge } from '@lentau/profile/user/shared/services/user-profile-signal-bridge.service';

export const PASSPORT_ID: InjectionToken<Signal<string>> = new InjectionToken('PASSPORT_ID', {
  providedIn: 'root',
  factory: (): Signal<string> => inject(UserProfileSignalBridge).passportId,
});
